import Loading from '@/components/Loading/Loading';
import { COLLECTION_LIST } from './constants';
import { useYouMayAlsoLike } from './useYouMayAlsoLike';
import CollectionSlider from '@/components/homepage/CollectionsSlider';
import { FallbackCarouselProps } from './types';

const FallBackCarousel = ({ sectionClasses }: FallbackCarouselProps) => {
  const collectionOffers = useYouMayAlsoLike(
    COLLECTION_LIST['popular-gadgets'],
  );

  if (!collectionOffers) return <Loading />;

  // Display fallback Popular Gadgets
  return (
    <>
      {collectionOffers.length > 0 && (
        <div className={sectionClasses}>
          <CollectionSlider
            title="You May Also Like"
            dealTitle="View All"
            offers={collectionOffers}
            collectionHandle={'popular-gadgets'}
            hideViewAll
            displayPrice
          />
        </div>
      )}
    </>
  );
};

export default FallBackCarousel;
